// Module
var code = "<div class=\"spark-line-container\"> <svg class=\"spark-line\"> <g class=\"series-container\"> <path style=\"fill:none;stroke:#39c;stroke-width:1px\"></path> </g> <g class=\"average-label\"> <rect></rect> <text class=\"value-label\"></text> </g> </svg> </div>";
// Exports
module.exports = code;